import { render, staticRenderFns } from "./Baidu.vue?vue&type=template&id=ca825b06&scoped=true"
import script from "./Baidu.vue?vue&type=script&lang=js"
export * from "./Baidu.vue?vue&type=script&lang=js"
import style0 from "./Baidu.vue?vue&type=style&index=0&id=ca825b06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca825b06",
  null
  
)

export default component.exports